/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown>, muscles: NonNullable<unknown> }} Wrapped_Share_Muscles_TargetInputs */

const en_us2_wrapped_share_muscles_target = /** @type {(inputs: Wrapped_Share_Muscles_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I closed the week of ${i?.range} with ${i?.muscles}. My Pocket Gym.`)
};

const pt_br2_wrapped_share_muscles_target = /** @type {(inputs: Wrapped_Share_Muscles_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fechei a semana de ${i?.range} com ${i?.muscles}. My Pocket Gym.`)
};

const es_419_wrapped_share_muscles_target = /** @type {(inputs: Wrapped_Share_Muscles_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cerré la semana del ${i?.range} con ${i?.muscles}. My Pocket Gym.`)
};

const pt_pt2_wrapped_share_muscles_target = /** @type {(inputs: Wrapped_Share_Muscles_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fechei a semana de ${i?.range} com ${i?.muscles}. My Pocket Gym.`)
};

const fr_fr2_wrapped_share_muscles_target = /** @type {(inputs: Wrapped_Share_Muscles_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`J'ai bouclé la semaine du ${i?.range} avec ${i?.muscles}. My Pocket Gym.`)
};

const de_de2_wrapped_share_muscles_target = /** @type {(inputs: Wrapped_Share_Muscles_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Woche vom ${i?.range} mit ${i?.muscles} abgeschlossen. My Pocket Gym.`)
};

const it_it2_wrapped_share_muscles_target = /** @type {(inputs: Wrapped_Share_Muscles_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ho chiuso la settimana del ${i?.range} con ${i?.muscles}. My Pocket Gym.`)
};

/**
* | output |
* | --- |
* | "I closed the week of {range} with {muscles}. My Pocket Gym." |
*
* @param {Wrapped_Share_Muscles_TargetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_share_muscles_target = /** @type {((inputs: Wrapped_Share_Muscles_TargetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Share_Muscles_TargetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_share_muscles_target(inputs)
	if (locale === "es-419") return es_419_wrapped_share_muscles_target(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_share_muscles_target(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_share_muscles_target(inputs)
	if (locale === "de-DE") return de_de2_wrapped_share_muscles_target(inputs)
	if (locale === "it-IT") return it_it2_wrapped_share_muscles_target(inputs)
	return en_us2_wrapped_share_muscles_target(inputs)
});
export { wrapped_share_muscles_target as "wrapped.share_muscles_target" }